<div class="viewer">
  <ng-content></ng-content>
</div>
